module.exports = __webpack_public_path__ + "static/media/codeKingOfTheHill.9a461189.gif";